import { Component, Input} from '@angular/core';
import { EmployeeApplicationStatus } from '../../models/EmployeeApplication';

@Component({
    selector: 'app-employee-application-status',
    template: `
<span class="badge"
        [class.text-bg-primary]="value == 'Synced'"
        [class.text-bg-secondary]="value == 'Registered'"
        [class.text-bg-light]="value == 'Submitted'"
        [class.text-bg-warning]="value == 'Review'"
        [class.text-bg-success]="value == 'Approved'"
        [class.text-bg-danger]="value == 'Rejected'"
        [class.text-bg-dark]="value == 'Deleted'">
    {{'employeeApplicationStatus_' + value | translate}}
</span>
`
})
export class EmployeeApplicationStatusComponent {
    @Input() value: EmployeeApplicationStatus;
}
